<template>
  <div
    v-if="shouldShowBanner"
    :class="[
      'pointer-events-none fixed top-0 left-0 z-50 w-full text-white py-3 px-4 shadow-md flex items-center',
      storeStatus === 'closed' ? 'bg-red-600' : 'bg-yellow-600'
    ]"
  >
    <div class="container mx-auto flex items-center justify-center gap-2">
      <AlertCircle class="w-5 h-5 flex-shrink-0" />
      <p class="text-sm font-medium text-center">
        {{ bannerMessage }}
      </p>
    </div>
  </div>
</template>

<script>
import { AlertCircle } from "lucide-vue";
import { useSelectedStore } from "@/composables/useSelectedStore";

export default {
  name: "LocationClosedBanner",
  components: {
    AlertCircle
  },
  created() {
    this._selectedStore = useSelectedStore(this.$store);
  },
  computed: {
    storeStatus() {
      if (this._selectedStore) {
        return this._selectedStore.getStoreStatus();
      }
      return "open";
    },
    shouldShowBanner() {
      // Show banner if status is 'closed' or 'schedule_only'
      return (
        this.storeStatus === "closed" || this.storeStatus === "schedule_only"
      );
    },
    bannerMessage() {
      if (this.storeStatus === "schedule_only") {
        return "This location is currently closed, but you can schedule your order for a later time.";
      }
      // Default message for 'closed' status
      return "This location is currently closed at this time.";
    }
  }
};
</script>
